import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';
import { exportQueryKeys } from './exportQueryKeys.js';

const useInvalidateQueryExportRequests = () => {
  const queryClient = useQueryClient();
  return useCallback(() => queryClient.invalidateQueries({
    queryKey: [
      exportQueryKeys.exportRequests()[0]
    ]
  }), [
    queryClient
  ]);
};

export { useInvalidateQueryExportRequests };
//# sourceMappingURL=useInvalidateQueryExportRequests.js.map
